/**
 * Class PdpUpdater, which is used to update PDP by using handlebars templates
 */

define([
    'jquery',
    'handlebars'
], (
    $,
    Handlebars
) => {
    class PdpUpdater {

        /**
         * Constructor
         *
         * @param {Object}  config Configuration options passed in through JSON
         *
         * @returns {null}
         */
        constructor(config) {
            const defaultConfig = {};
            // Merge default config options and provided config
            this.config = { ...defaultConfig, ...config };

            this.groupedProductsData = this.config.groupedProductsData;
            this.$titleContainer = $('.product-right-pane .product-title-container');
            this.$addToBagForm = $('.product-add-form form');
            this.$promoNotesContainer = $('.product.attribute.promo-notes .value');
            this.$itemsPriceInfoTableContainer = $('[data-js="product-items-price-info-table-container"]');
            this.$accessoriesPriceInfoTableContainer = $('[data-js="product-accessories-price-info-table-container"]');
            this.$designerNotesContainer = $('#product\\.info\\.designer\\.notes .value');
            this.$productDetailsContainer = $('[data-js="attribute_product_details"]');
            this.$careInstructionsContainer = $('[data-js="attribute_care_instructions"]');
            this.$styleWithProductsContainer = $('.product-items');
            this.$totalPriceAmountContainer = $('.grouped-total');
            this.$addToCartActionsContainer = $('.add-to-cart__actions');
            this.$boxToCartQtyContainer = $('.box-tocart__qty');
            this.$groupedTotalContainer = $('.grouped-total-container');

            this.titleTemplate = Handlebars.compile($('#product-title-template').html());
            this.priceInfoTableTemplate = Handlebars.compile($('#product-price-info-table-template').html());
            this.styleWithProductsTemplate = Handlebars.compile($('#style-width-products').html());

            this.attachListeners();
        }

        /**
         * Attach event listeners to elements
         *
         * @returns {null}
         */
        attachListeners() {
            /**
             * Get content from groupedProductsData for the clicked swatch color and update product details section
             *
             * @returns {null}
             */
            $(document).on('click', '.swatch-option.color', (e) => {
                this.updateProductDetails(this.groupedProductsData[$(e.currentTarget).attr('data-option-id')], true);
            });

            /**
             * Get content from groupedProductsData for the clicked swatch image and update product details section
             *
             * @returns {null}
             */
            $(document).on('click', '.swatch-option.image', (e) => {
                this.updateProductDetails(this.groupedProductsData[$(e.currentTarget).attr('data-option-id')]);
            });

            /**
             * Get content from groupedProductsData for the selected swatch and update product details section after swatch intialized
             *
             * @returns {null}
             */
            $(document).on('swatch.initialized', () => {
                this.updateProductDetails(this.groupedProductsData[$('.swatch-option.color.selected').attr('data-option-id')]);
            });


            //If this is a simple product or a product with no swatches, add the relevant classes
            //to related and up sell product images so they look square
            if ( $(".swatch-option.color").length + $(".swatch-option.image").length == 0 ){
                this.updateSimpleStyleWithProducts();
            }

            const productDataKeys = Object.keys(this.groupedProductsData);
            if (productDataKeys?.length === 1) {
                const productData = this.groupedProductsData[productDataKeys[0]];
                if (productData.upsell_products && productData.upsell_products.length) {
                    this.bindUpSellProductsNavigationListeners();
                }

                if (productData.related_products && productData.related_products.length) {
                    this.bindRelatedProductsNavigationListeners();
                }
            }
        }

        /**
         * Update product details
         *
         * @param {object} groupedProductData
         *
         * @param onSwatchClick
         * @returns {null}
         */
        updateProductDetails(groupedProductData, onSwatchClick = false) {
            if (typeof groupedProductData === 'undefined') {
                return;
            }

            this.updateTitleSection(groupedProductData);

            this.updateStickyHight(groupedProductData);

            this.updateAddtoBagForm(groupedProductData);

            this.updatePromoNotes(groupedProductData);

            this.updatePriceInfoTable(groupedProductData);

            this.updateInformationTabs(groupedProductData);

            this.updateStyleWithProducts(groupedProductData, onSwatchClick);

            this.updateTotalPriceAmount(groupedProductData);

            this.updateAddToCartSection(groupedProductData);
        }

        /**
         * Update product title section
         *
         * @param {object} groupedProductData
         *
         * @returns {null}
         */
        updateTitleSection(groupedProductData) {
            if(this.$titleContainer.length) {
                this.$titleContainer.html(this.titleTemplate(groupedProductData));
            }

            const $mobileTitleContainer = $('.product-mobile-title-container .product-title-container');
            if($mobileTitleContainer.length) {
                $mobileTitleContainer.html(this.titleTemplate(groupedProductData));
            }
        }

        /**
         * Fixing the safari sticky gallery issue by setting the sticky-gallery-target height
         * to match the right pane height
	       *
         * @param {object} groupedProductData
         *
         * @returns {null}
         *
         */
        updateStickyHight(groupedProductData) {
            if (window.innerWidth >= 768) {
                var titleHeight = $(".product-title-container").height();
                var infoHeight = $(".product-info-container").height();
                var galleryHeight = $(".product-media-container").height();

                $(".sticky-gallery-target").css(
                    "height",
                    titleHeight + infoHeight - galleryHeight - 24 + "px"
                );
            }
        }

        /**
         * Update form attributes and value for associated elements underneath to make sure when product is
         * switched, the form can submit correct product information
         *
         * @param {object} groupedProductData
         *
         * @returns {null}
         */
        updateAddtoBagForm(groupedProductData) {
            if(!this.$addToBagForm.length) {
                return;
            }

            this.$addToBagForm.data('product-sku', groupedProductData['product_sku']);
            // change form submit url here, replace product id in url to what is clicked
            let oldAction = this.$addToBagForm.attr("action").slice(0, -1);
            const newAction = oldAction.substr(0, oldAction.lastIndexOf('/')) + '/' + groupedProductData['product_id'] + '/';

            this.$addToBagForm.attr("action", newAction);
            this.$addToBagForm.find('input[name=product]').val(groupedProductData['product_id']);
        }

        /**
         * Disable the add to cart button section for a grouped product if there are no simple products for the grouped
         * product that are sellable.
         *
         * @param {object} groupedProductData
         *
         * @returns {null}
         */
        updateAddToCartSection(groupedProductData) {
            if (groupedProductData['disable_addtocart']) {
                this.$boxToCartQtyContainer.hide();
                this.$addToCartActionsContainer.hide();
                this.$groupedTotalContainer.hide();
            } else {
                this.$boxToCartQtyContainer.show();
                this.$addToCartActionsContainer.show();
                this.$groupedTotalContainer.show();
            }
        }

        /**
         * Update product promotion notes
         *
         * @param {object} groupedProductData
         *
         * @returns {null}
         */
        updatePromoNotes(groupedProductDate) {
            let promoNotes = groupedProductDate['promo_notes'];
            if (typeof promoNotes !== 'undefined' && promoNotes !== '') {
                this.$promoNotesContainer.html(promoNotes);
            }
        }

        /**
         * Update product price information table
         *
         * @param {object} groupedProductData
         *
         * @returns {null}
         */
        updatePriceInfoTable(groupedProductData) {
            if(this.$itemsPriceInfoTableContainer.length) {
                this.$itemsPriceInfoTableContainer.html(this.priceInfoTableTemplate(groupedProductData['items']));
                this.$itemsPriceInfoTableContainer.trigger('contentUpdated');
            }

            if(this.$accessoriesPriceInfoTableContainer.length) {
                this.$accessoriesPriceInfoTableContainer.html(this.priceInfoTableTemplate(groupedProductData['accessories']));
                this.$accessoriesPriceInfoTableContainer.trigger('contentUpdated');
            }
        }

        /**
         * Update information tabs, mainly designer notes, and product details
         *
         * @param {object} groupedProductData
         *
         * @returns {null}
         */
        updateInformationTabs(groupedProductData) {
            if(this.$designerNotesContainer.length) {
                this.$designerNotesContainer.html(groupedProductData['designer_notes']);
            }

            if(this.$productDetailsContainer.length) {
                this.$productDetailsContainer.html(groupedProductData['product_details']);
            }

            if(this.$careInstructionsContainer.length) {
                if ( !$.trim(groupedProductData['care_instructions']) ){
                    this.$careInstructionsContainer.closest(".collapsible-item").addClass('hidden');
                }else{
                    this.$careInstructionsContainer.closest(".collapsible-item").removeClass('hidden');
                }
                this.$careInstructionsContainer.html(groupedProductData['care_instructions']);
            }
        }

        /**
         * Update Style With... products list
         *
         * @param {object} groupedProductData
         *
         * @param onSwatchClick
         * @returns {null}
         */
        updateStyleWithProducts(groupedProductData, onSwatchClick) {

            const upsellContainer = $('.upsell').removeClass('hidden');
            if(upsellContainer.length) {
                const productContainer = upsellContainer.find('.product-items');

                if (productContainer.hasClass('slick-initialized')) {
                    productContainer.slick('unslick');
                }

                productContainer.empty();
                const upsellTemplate = Handlebars.compile($('#style-width-upsell-products').html())
                productContainer.html(upsellTemplate(groupedProductData));
                if (groupedProductData.upsell_products && groupedProductData.upsell_products.length){
                    upsellContainer.show();

                    if (onSwatchClick) {
                        this.bindUpSellProductsNavigationListeners();
                    }
                }else{
                    upsellContainer.hide();
                }
            }

            const relatedContainer = $('.related').removeClass('hidden');
            if (relatedContainer.length) {
                const relatedProductsContainer = relatedContainer.find('.product-items');

                if (relatedProductsContainer.hasClass('slick-initialized')) {
                    relatedProductsContainer.slick('unslick');
                }
                relatedProductsContainer.empty();
                relatedProductsContainer.html(this.styleWithProductsTemplate(groupedProductData));
                if (groupedProductData.related_products && groupedProductData.related_products.length){
                    relatedContainer.show();

                    if (onSwatchClick) {
                        this.bindRelatedProductsNavigationListeners();
                    }
                }else{
                    relatedContainer.hide();
                }
            }
            this.$styleWithProductsContainer.trigger("init_slick");
        }


        /**
         * Updates styles for upsell and related product images when not in a grouped product
         */
        updateSimpleStyleWithProducts() {
            const itemsContainer = $('.upsell, .related').removeClass('hidden');
            if(itemsContainer.length) {
                const productContainer = itemsContainer.find('.product-items');
                $.each(productContainer.find(".product-item"), function(i,v){
                   if ($(v).find('.product-image-container').length){
                       $(v).find('.product-image-container')
                           .addClass('o-imagewrap')
                           .removeClass('product-image-container')
                           .removeAttr('style');
                   }
                   if ($(v).find('.product-image-wrapper').length){
                       $(v).find('.product-image-wrapper')
                           .addClass('o-image')
                           .removeClass('product-image-wrapper')
                           .removeAttr('style');
                   }
                   if ($(v).find('.product-image-photo').length){
                       $(v).find('.product-image-photo')
                           .addClass('photo image')
                           .removeClass('product-image-photo')
                           .removeAttr('style');
                   }
                });
            }
        }




        /**
         * Update total price amount
         *
         * @returns {null}
         */
        updateTotalPriceAmount(groupedProductData) {
            // make sure price text will always show 2 decimal places
            this.$totalPriceAmountContainer.html(groupedProductData['default_total'].toFixed(2));
            this.$totalPriceAmountContainer.trigger('contentUpdated');      //To update AfterPay installment amounts
        }

        bindRelatedProductsNavigationListeners() {
            const elements = document.getElementsByClassName('related')[0].querySelectorAll('li');

            elements.forEach( element => {
                const name = element.querySelector('a.product-item-link').innerText;
                const anchorElements = element.querySelectorAll('a[href]');

                anchorElements.forEach((linkElement) => {
                    linkElement.addEventListener('click', (event) => {
                        if (window.dataLayer && window.dataLayer.push) {
                            window.dataLayer.push({
                                event: 'related_products_interaction',
                                ecommerce: {
                                    url: event.target.href || event.currentTarget.href,
                                    name
                                }
                            })
                        }
                    });
                });
            });
        }

        bindUpSellProductsNavigationListeners() {
            const elements = document.getElementsByClassName('upsell')[0].querySelectorAll('li');

            elements.forEach((element) => {
                const name = element.querySelector('a.product-item-link').innerText;
                const anchorElements = element.querySelectorAll('a[href]');

                anchorElements.forEach((linkElement) => {
                    linkElement.addEventListener('click', (event) => {
                        if (window.dataLayer && window.dataLayer.push) {
                            window.dataLayer.push({
                                event: 'upsell_interaction',
                                ecommerce: {
                                    url: event.target.href || event.currentTarget.href,
                                    name
                                }
                            })
                        }
                    });
                })

            });
        }
    }

    return (config) => {
        const pdpUpdater = new PdpUpdater(config);
        return pdpUpdater;
    };
});
